import {useEffect, useState} from 'react';

import {NAV_AND_VIEW_BAR_OFFSET, VIEW_BAR_HEIGHT} from './constants';

/**
 * CSS length for the top edge of a drawer docked beside the workspace: below
 * the app navbar (or, under Forge, the shell header) and the workspace view
 * bar, following both as the page scrolls them out of view.
 *
 * `--wb-docked-drawer-top` (src/css/layout-tokens.css) supplies the header
 * part, so one expression is right both standalone and under Forge. The scroll
 * position is subtracted in JS because CSS cannot read it. Under Forge the
 * document itself never scrolls, so the offset stays at header plus view bar.
 */
export function useWorkspaceDrawerTop(): string {
  const [scrollY, setScrollY] = useState(clampedScrollY);

  useEffect(() => {
    const update = () => setScrollY(clampedScrollY());
    update();
    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update, {passive: true});
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return `max(0px, calc(var(--wb-docked-drawer-top) + ${VIEW_BAR_HEIGHT}px - ${scrollY}px))`;
}

// Once both bars are scrolled away the offset is 0 whatever the exact scroll
// position, so clamp the state there and stop re-rendering on further scrolls.
function clampedScrollY(): number {
  return Math.min(Math.ceil(window.scrollY), NAV_AND_VIEW_BAR_OFFSET);
}
